import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryEmpty: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="battery-empty, power"><path fillRule="evenodd" clipRule="evenodd" d="M1 6.75C1 5.7835 1.7835 5 2.75 5H18.25C19.2165 5 20 5.7835 20 6.75V8H21.75C22.4404 8 23 8.55964 23 9.25V14.75C23 15.4404 22.4404 16 21.75 16H20V17.25C20 18.2165 19.2165 19 18.25 19H2.75C1.7835 19 1 18.2165 1 17.25V6.75ZM20 14.5H21.5V9.5H20V14.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBatteryEmpty;
